import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { decodeURI } from 'utils/helpers/url';

// pending :: bool
// currentSelection :: object
const useSetLoadingTitle = (pending, currentSelection) => {
  const [title, setTitle] = useState('Loading...');
  const { viewById } = useParams();
  const { pathname } = useLocation();
  const authorizationType = pathname.split('/')[5];

  // if pending set to Loading
  // if viewById, decode and set to viewById in URL
  // if not pending and current selection is empty, set to authType in URL
  useEffect(() => {
    if (pending) {
      setTitle('Loading...');
    } else if (currentSelection?.nameShort) {
      setTitle(currentSelection.nameShort);
    } else if (currentSelection?.carrierName) {
      setTitle(currentSelection.carrierName);
    } else if (viewById) {
      setTitle(decodeURI(viewById));
    } else if (authorizationType) {
      setTitle(authorizationType);
    }
  }, [
    viewById,
    pending,
    currentSelection?.nameShort,
    currentSelection?.carrierName,
    authorizationType,
  ]);

  return title;
};

export default useSetLoadingTitle;
